export default {
    namespaced: true,
    state: {
        vdx_checkboxes: []
    },
    getters: {},
    mutations: {
        setVDXCheckBoxes(state, ids) {
            state.vdx_checkboxes = ids;
        },
        clearVDXCheckBoxes(state) {
            state.vdx_checkboxes = [];
        }
    },
    actions: {
        clearVDXCheckBoxes({ commit }) {
            commit('clearVDXCheckBoxes');
        },
        setVDXCheckBoxes({ commit }, ids) {
            commit('setVDXCheckBoxes', ids);
        },
    },
}